import { useEffect, useState } from 'react';

/**
 * State machine that decides whether to render the celebration after the carousel's
 * tasks transition from N>0 to 0.
 *
 * Re-arms each time tasks reappear, so dismissing the celebration once won't suppress
 * future completions. Returns `show: false` whenever `enabled` is false so consumers
 * that opt out (e.g. scoped carousels like Accounting Overview) skip the work entirely.
 */
export default function useTaskCarouselCelebration(taskCount: number, enabled: boolean) {
    const [hasSeenTasks, setHasSeenTasks] = useState(false);
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        if (!enabled) {
            return;
        }
        if (taskCount > 0) {
            setHasSeenTasks(true);
            setDismissed(false);
        }
    }, [enabled, taskCount]);

    const show = enabled && taskCount === 0 && hasSeenTasks && !dismissed;
    const dismiss = () => setDismissed(true);

    return { show, dismiss };
}
